import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { useAppDispatch } from '../../../store/hooks';
import { getExceptedApps } from '../components/excepted-apps-release-form/thunks/get-excepted-apps.thunk';
import { getAppDetailsById } from '../thunks/get-app-details-by-id.thunk';
import { normalizeAppName } from '../utils/normalize-app-name.util';

export const useIsExceptedApp = (): boolean => {
  const dispatch = useAppDispatch();
  const { id: appId } = useParams();
  const parsedAppId = useMemo(() => parseInt(appId as string, 10), [appId]);
  const [isExceptedApp, setIsExceptedApp] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = false;

    if (!appId || isNaN(parsedAppId)) {
      return;
    }

    Promise.all([
      dispatch(getAppDetailsById(parsedAppId)).unwrap(),
      dispatch(getExceptedApps()).unwrap(),
    ]).then(([appDetailsResult, exceptedAppsResult]) => {
      const found = exceptedAppsResult.some(
        app =>
          normalizeAppName(app.name) === normalizeAppName(appDetailsResult.name)
      );

      if (!isMounted && found !== isExceptedApp) {
        setIsExceptedApp(found);
      }
    });

    return () => {
      isMounted = true;
    };
  }, [appId, parsedAppId]);

  return isExceptedApp;
};
